import { call, put, takeEvery } from "redux-saga/effects";

// Crypto Redux States
import {
  ADD_NEW_LOCATION,
  DELETE_LOCATION,
  GET_LOCATIONS,
  UPDATE_LOCATION,
  UPDATE_LOCATION_STATUS
} from "./actionTypes";

import {
  addLocationFail,
  addLocationSuccess,
  deleteLocationFail,
  deleteLocationSuccess,
  getLocationsFail,
  getLocationsSuccess,
  setState,
  updateLocationFail,
  updateLocationSuccess,
} from "./actions";

import { toast } from 'react-toastify';
import { locations, updateStatus } from "../../../helpers/adipiBackendUrl";
import { deleteApiCall, getTable, patchApiCall, postApiCall } from "../../../services/mainServices";

function* fetchLocations({ payload: { params } }) {
  try {
    yield put(setState(true));
    const response = yield call(getTable, locations, params.toString());
    yield put(setState(false));
    yield put(getLocationsSuccess(response.items, response.totalPages, response.currentPage));
  } catch (error) {
    yield put(setState(false));
    yield put(getLocationsFail(error));
  }
}

function* updateLocation({ payload: locationObj }) {
  try {
    const { id, recordStatus, ...rest } = locationObj;
    yield call(patchApiCall, `${locations}/${id}`, rest);
    const response = yield call(getTable, `${locations}/${locationObj.id}`);
    yield put(updateLocationSuccess(response));
    toast.success('Registro actualizado correctamente');
  } catch (error) {
    yield put(updateLocationFail(error));
    toast.error('Error al actualizar el registro');
  }
}

function* updateLocationStatus({ payload: locationObj }) {
  try {
    const { id } = locationObj;
    yield call(patchApiCall, `${locations}/${updateStatus}/${id}`, { recordStatus: locationObj.recordStatus });
    const response = yield call(getTable, `${locations}/${locationObj.id}`);
    yield put(updateLocationSuccess(response));
  } catch (error) {
    yield put(updateLocationFail(error));
  }
}

function* deleteLocation({ payload: locationObj }) {
  try {
    yield call(deleteApiCall, `${locations}/${locationObj.id}`);
    yield put(deleteLocationSuccess(locationObj.id));
    toast.success('Registro borrado correctamente');
  } catch (error) {
    yield put(deleteLocationFail(error));
    toast.error('Error al borrar el registro');
  }
}

function* postingLocation({ payload: location }) {
  try {
    const response = yield call(postApiCall, locations, location);
    yield put(addLocationSuccess(response));
    toast.success('Registro agregado correctamente');
  } catch (error) {
    yield put(addLocationFail(error));
    toast.error('Error al agregar el registro');
  }
}

function* locationsSaga() {
  yield takeEvery(GET_LOCATIONS, fetchLocations);
  yield takeEvery(ADD_NEW_LOCATION, postingLocation);
  yield takeEvery(UPDATE_LOCATION, updateLocation);
  yield takeEvery(UPDATE_LOCATION_STATUS, updateLocationStatus);
  yield takeEvery(DELETE_LOCATION, deleteLocation);
}

export default locationsSaga;
